import { render, staticRenderFns } from "./DeviceTab.vue?vue&type=template&id=0dd9b486"
import script from "./DeviceTab.vue?vue&type=script&lang=js"
export * from "./DeviceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports